import { useCallback, useRef, useState } from 'react'
import { FallbackImageSizes } from 'atoms/FallbackImage'
import { ImagePoster } from 'atoms/ImagePoster'
import { COLOR } from 'vars/color'
import { PosterContainerBlurSC } from './PosterContainerBlur.styled'

export const PosterContainerBlur = ({ posterUrl }: { posterUrl: string }) => {
  const posterRef = useRef<HTMLImageElement>(null)
  const [isPosterVertical, setIsPosterVertical] = useState<boolean>(false)

  const checkPosterAspectRatio = useCallback(() => {
    if (posterRef.current) {
      setIsPosterVertical(posterRef.current!.width > posterRef.current!.height)
    }
  }, [])

  return (
    <PosterContainerBlurSC
      backgroundImage={isPosterVertical ? posterUrl : null}
    >
      <ImagePoster
        posterUrl={posterUrl}
        imageRef={posterRef}
        handleLoading={checkPosterAspectRatio}
        fallbackImageBackground={COLOR.TEXT_ICON_CONSTANT_DARK}
        fallbackImageColor={COLOR.TEXT_ICON_TERTIARY}
        fallbackImageSize={FallbackImageSizes.M}
      />
    </PosterContainerBlurSC>
  )
}
